import { LeaveManagementTable, LeaveListPageHeader } from './components';

const LeaveManagementList = () => {
  return (
    <div className="d-flex flex-column gap-10 p-10">
      <LeaveListPageHeader />
      <LeaveManagementTable />
    </div>
  );
};

export default LeaveManagementList;
